import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TimezoneService {
  timeZone = 'api/TimeZone';
  constructor(private _timezoneHttp: RestApi) { }

  getTimeZonesList(): Observable<any> {
    return this._timezoneHttp.get(`${this.timeZone}/GetTimeZonesList`);
  }

  getTimeZoneConfiguration(): Observable<any> {
    return this._timezoneHttp.get(`${this.timeZone}/GetTimeZoneConfiguration`);
  }

  getUserTimeZone(): Observable<any> {
    return this._timezoneHttp.get(`${this.timeZone}/UserTimeZone`);
  }

  saveUserTimeZone(typeConfiguration): Observable<any> {
    return this._timezoneHttp.post(`${this.timeZone}/UserTimeZone`, typeConfiguration);
  }

  showServerTime(): Observable<boolean> {
    return this._timezoneHttp.get(`${this.timeZone}/ShowServerTime`);
  }

  showTimeZoneRegion(): Observable<boolean> {
    return this._timezoneHttp.get(`${this.timeZone}/ShowTimeZoneRegion`);
  }

  saveEnvironmentTimeZone(timezone: any): Observable<any> {
    return this._timezoneHttp.post(`${this.timeZone}/SaveEnvironmentTimeZone`, timezone);
  }
}
